import { defineComponent as _defineComponent } from 'vue'
import type { ElementUISlotScope, ColumnInfo, TableFormatter } from '@/lib/types/components';

// Props definizione per TypeScript
interface Props {
	dataOrder?: any;
}

// Props con defaults

export default /*#__PURE__*/_defineComponent({
  __name: 'ElTableColumnSortable',
  props: {
    dataOrder: { default: null }
  },
  emits: ['orderChanged'],
  setup(__props: any, { emit }) {

const props = __props as { dataOrder: any };



// Events


// Adapter function per convertire ElementUISlotScope['column'] in ColumnInfo
function adaptScopeToColumnInfo(column: ElementUISlotScope['column']): ColumnInfo {
	return {
		column: {
			property: column.property,
			label: column.label,
		},
	};
}

// Event handler con type safety
function onOrderChange(propertyName: string, direction: string): void {
	emit('orderChanged', propertyName, direction);
}

// Content evaluation con type safety e formatter support
function evaluateContent(column: any, row: any, index: number): string | null {
	const cellValue = resolveProperty(column.property, row);

	if (column.formatter && typeof column.formatter === 'function') {
		try {
			// Usa il TableFormatter con signature (row, column, cellValue)
			return (column.formatter as TableFormatter)(row, column, cellValue);
		} catch (error) {
			console.error('❌ ERROR ElTableColumnSortable.withDefaults:', error);
			console.warn('Formatter error:', error);
			return String(cellValue);
		}
	}

	if (cellValue == null) {
		return null;
	}

	return String(cellValue);
}

// Property resolver helper con type safety
function resolveProperty(path: string, obj: any): any {
	if (!path || !obj) {
		return null;
	}

	return path.split('.').reduce((prev, curr) => {
		return prev?.[curr] ?? null;
	}, obj);
}

return { __sfc: true,props, emit, adaptScopeToColumnInfo, onOrderChange, evaluateContent, resolveProperty }
}

})